import _extends from "@babel/runtime/helpers/extends";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import ReactSelect from "react-select";
import FieldFrame from "../FieldFrame";
import customStyles, { baseStyles } from "./styles";

const enhanceSelect = Component => /*#__PURE__*/React.memo(function Select(props) {
  // eslint-disable-next-line react/prop-types
  const {
    size,
    disabled,
    className,
    label,
    hasError,
    errorMessage,
    styles,
    withShadow,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(FieldFrame, {
    className: className,
    errorMessage: errorMessage,
    disabled: disabled,
    hasError: hasError,
    value: otherProps.value,
    label: label,
    size: size,
    isRtl: otherProps.isRtl
  }, _ref => {
    let {
      className: classNameControl
    } = _ref;
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: classNameControl,
      isDisabled: disabled,
      styles: { ...customStyles,
        ...styles
      },
      placeholder: ""
    }, otherProps));
  });
});

const Select = enhanceSelect(ReactSelect);
Select.baseStyles = baseStyles;
const _default = Select;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(enhanceSelect, "enhanceSelect", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Select/Select.jsx");
  reactHotLoader.register(Select, "Select", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Select/Select.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/Select/Select.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();